export const UsageService = Symbol('UsageService');

/**
 * 用量服务接口
 *
 * 提供各类功能的剩余用量查询能力
 */
export interface UsageService {
    /**
     * 是否还有 CN 说明书用量
     */
    readonly hasCnPatentSpecificationUsage: boolean;

    /**
     * 是否还有 US 说明书用量
     */
    readonly hasUsPatentSpecificationUsage: boolean;

    /**
     * 是否还有 EU 说明书用量
     */
    readonly hasEuPatentSpecificationUsage: boolean;

    /**
     * 是否还有说明书用量（CN、US、EU 任一有剩余）
     */
    readonly hasPatentSpecificationUsage: boolean;

    /**
     * 是否还有查新报告用量
     */
    readonly hasNoveltySearchUsage: boolean;

    /**
     * 是否还有 FTO 报告用量
     */
    readonly hasFtoSearchUsage: boolean;
}
